import React from "react";

function ReasonForNotOrdering({ formData, setFormData, selected, buttonStyle }) {
  const handleReasonClick = (reason) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      reasonForNotOrdering: reason,
    }));
  };

  const reasons = [
    { label: "Discontinued", value: "Discontinued" },
    { label: "Escalation", value: "Escalation" },
    { label: "Bulk", value: "Bulk" },
    { label: "Ordered", value: "Ordered" },
    { label: "Financial Issues", value: "Financial Issues" },
    { label: "No Results", value: "No Results" },
    { label: "Visited another dermat", value: "Visited another dermat" },
    { label: "Irregular", value: "Irregular" },
  ];

  return (
    <div className=" my-3">
      <div className='d-flex align-itms-center justify-content-between border-bottom border-1 p-2'>
        <h4 className='flex-1 align-self-center p-0 m-0'>Reason for not ordering</h4>

        <div className='flex-1 d-flex flex-wrap gap-3 mt-3'>
        {reasons.map((reason) => (
              <p
                key={reason.value}
                style={{ minWidth: "7rem" }}
                onClick={() => handleReasonClick(reason.value)}
                className={
                  formData.reasonForNotOrdering === reason.value
                    ? selected
                    : buttonStyle
                }
              >
                {reason.label}
              </p>
            ))}
        </div>
      </div>
    </div>
  );
}

export default ReasonForNotOrdering;
